import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedLoadingComponent } from './components/loading/shared.loading.component';
import { SharedreturnMerchantComponent } from './components/return_merchant/shared.return_merchant.component';
import { MaterialModule } from '../material.module';
import { GenericButtonComponent } from '../components/generic-button/generic-button.component';
import { MethodsNotFoundAlertComponent } from './components/methods-not-found-alert/methods-not-found-alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { PrivacyConditionsComponent } from './components/privacy-conditions/privacy-conditions.component';
import { RecommendationsBannerComponent } from './components/recommendations-banner/recommendations-banner.component';
import { DownloadCashInstructionsButtonComponent } from './components/download-cash-instructions-button/download-cash-instructions-button.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule
  ],
  declarations: [
    SharedLoadingComponent,
    SharedreturnMerchantComponent,
    GenericButtonComponent,
    MethodsNotFoundAlertComponent,
    PrivacyConditionsComponent,
    RecommendationsBannerComponent,
    DownloadCashInstructionsButtonComponent,
  ],
  exports: [
    SharedLoadingComponent,
    SharedreturnMerchantComponent,
    GenericButtonComponent,
    MethodsNotFoundAlertComponent,
    PrivacyConditionsComponent,
    RecommendationsBannerComponent,
    DownloadCashInstructionsButtonComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
}
